import React from "react";
import { FormattedMessage } from "react-intl";
import { Outlet } from "react-router";
import PageTitle from "components/PageTitle";
import { NavList } from "components/Nav";
import { useLinks } from "hooks";

/**
 * PlatformSettings
 */
const PlatformSettings = () => {
  const links = useLinks();
  const pages = [
    {
      label: <FormattedMessage id="Settings.PlatformAccess.Title" />,
      to: links.platform_settings,
      isActive: true,
      end: true,
    },
    {
      label: <FormattedMessage id="Events.MissionEvents.Title" />,
      to: links.setting_mission_events,
      isActive: true,
      end: true,
    },
    {
      label: <FormattedMessage id="Settings.CodeChallenges.H1" />,
      to: links.settings_code_challenges,
      isActive: true,
      end: true,
    },
    {
      label: <FormattedMessage id="Settings.Interviews.Title" />,
      to: links.settings_video_presentations,
      isActive: true,
      end: true,
    },
    {
      label: <FormattedMessage id="Settings.Blueprints.Title" />,
      to: links.settings_blueprints,
      isActive: true,
      end: false,
    },
    {
      label: <FormattedMessage id="Settings.Tags.Title" />,
      to: links.settings_tag_manager,
      isActive: true,
      end: true,
    },
  ];

  return (
    <>
      <PageTitle
        title={<FormattedMessage id="Settings.PlatformAccess.Back" />}
        actionBar={<NavList pages={pages} routerEnabled />}
        asHeader
      />
      <Outlet />
    </>
  );
};

export default PlatformSettings;
